module.exports = __webpack_public_path__ + "img/loyalty.68ac0b2e.svg";